export const isValidIndex = (value: number | string | null | undefined): boolean => {
  if (value === null || value === undefined) return false;
  const num = Number(value);
  return Number.isFinite(num) && num >= 0;
};

const gcd = (a: number, b: number): number => (b === 0 ? a : gcd(b, a % b));

export const getAspectRatio = (width: number, height: number): string => {
  if (!width || !height) return '- : -';
  const divisor = gcd(Math.abs(width), Math.abs(height));
  const decimal = (width / height).toFixed(4);
  return `${width / divisor}:${height / divisor} (${decimal})`;
};
